import React, { createContext, useCallback, useContext, useEffect, useState } from "react";

export const LANG_CODES = ["en", "ar"];
const STORAGE_KEY = "lep_lang_v1";

// Translation dictionary.
// Brand names + the hero headline "DO IT WITH LOVE" remain untouched per brief.
export const TRANSLATIONS = {
  en: {
    header: {
      orderUKFull: "Order Your Photos (UK)",
      orderUAEFull: "Order Your Photos (UAE)",
      orderUKShort: "UK",
      orderUAEShort: "UAE",
      orderPhotos: "Order Photos",
      tagline: "The No.1 Nursery & School Photography Supplier",
      language: "Language",
    },
    hero: {
      slogan: "The No.1 Nursery & School Photography Supplier",
      hashtags: "#loveexclusiveuk  ·  #loveexclusiveuae  ·  #ifoundmysmile",
      clickMe: "click the word LOVE!",
      bookShoot: "Book Your Shoot",
      preparing1: "Preparing",
      preparing2: "your magic…",
      loading: "Loading",
      ready: "It's ready.",
      clickReady: "Click me when ready",
      dismiss: "Dismiss",
    },
    seasons: {
      overline: "Four Seasons · One Love",
      "spring-summer": "Spring / Summer",
      "autumn-winter": "Autumn / Winter",
      graduation: "Graduation",
      schools: "Schools",
    },
    final: {
      line1: "Ready to book",
      line2: "your shoot?",
      book: "Book Your Shoot",
      contact: "Contact",
    },
    redirect: {
      toUK: "Redirecting to UK Shop",
      toUAE: "Redirecting to UAE Shop",
      loading: "Loading",
    },
    cookies: {
      title: "Cookies",
      body:
        "We use a handful of cookies to keep the site running smoothly and to understand what's working. No ads, no selling data.",
      accept: "Accept",
      decline: "Decline",
    },
    booking: {
      orderTitle: "Order photos",
      bookTitle: "Book a shoot",
      replyNote: "We reply within 24 hours",
      name: "Name",
      org: "Nursery / School",
      email: "Email",
      phone: "Phone",
      territory: "Territory",
      shootType: "Shoot type",
      shootTypes: {
        "spring-summer": "Spring / Summer",
        "autumn-winter": "Autumn / Winter",
        graduation: "Graduation",
        schools: "Schools",
        other: "Other",
      },
      message: "Message",
      messagePlaceholderBook: "Dates, age group, anything else…",
      messagePlaceholderOrder: "Gallery code, quantities, anything else…",
      send: "Send",
      sending: "Sending…",
      success: "Booking enquiry received.",
      successOrder: "Order request received. We'll be in touch.",
      error: "Something went wrong. Check your details and try again.",
      validation: "Please complete name, organisation, email and phone.",
    },
    contactDialog: {
      title: "Contact",
      send: "Send",
      sending: "Sending…",
      success: "Message received. Speak soon.",
      error: "Something went wrong. Please try again.",
      validation: "Please fill in name, email and message.",
      name: "Name",
      email: "Email",
      message: "Message",
    },
    notice: [
      "Welcome to Love Exclusive Photography",
      "Notice for Nursery / Schools: Pre-book your next photoshoot for 2026 early to guarantee your dates",
      "You can now order your photos online using your unique access code",
      "Notice: Early bird orders can receive up to £15 OFF",
      "Once you are registered for your photoshoot, you will be notified when your photos are ready to view",
      "Register your child through our new QR code technology at your nursery / school",
      "We have now expanded into the UAE providing photography for nurseries and schools",
    ],
    footer: {
      copyright:
        "© 2026 Love Exclusive Photography apart of Love Exclusive LLC © All Rights Reserved.",
    },
    badge: {
      years: "Years",
      anniversary: "Anniversary",
      aria: "10 Years Anniversary",
    },
    anniv: {
      kicker: "2016 — 2026",
      title: "Celebrating 10 Years of Love",
      subtitle: "Thank you for being part of our journey.",
      continue: "Continue",
    },
    lang: { en: "English", ar: "العربية" },
  },

  ar: {
    header: {
      orderUKFull: "اطلب صورك (المملكة المتحدة)",
      orderUAEFull: "اطلب صورك (الإمارات)",
      orderUKShort: "المملكة",
      orderUAEShort: "الإمارات",
      orderPhotos: "اطلب الصور",
      tagline: "المورّد الأول لتصوير الحضانات والمدارس",
      language: "اللغة",
    },
    hero: {
      slogan: "المورّد الأول لتصوير الحضانات والمدارس",
      hashtags: "#loveexclusiveuk  ·  #loveexclusiveuae  ·  #ifoundmysmile",
      clickMe: "اضغط كلمة LOVE!",
      bookShoot: "احجز جلستك",
      preparing1: "جارٍ التحضير",
      preparing2: "للحظة ساحرة…",
      loading: "تحميل",
      ready: "جاهز.",
      clickReady: "اضغط الآن للاحتفال",
      dismiss: "إلغاء",
    },
    seasons: {
      overline: "أربعة فصول · حبٌّ واحد",
      "spring-summer": "الربيع / الصيف",
      "autumn-winter": "الخريف / الشتاء",
      graduation: "التخرج",
      schools: "المدارس",
    },
    final: {
      line1: "هل أنت مستعد",
      line2: "لحجز جلستك؟",
      book: "احجز جلستك",
      contact: "تواصل معنا",
    },
    redirect: {
      toUK: "إعادة توجيه إلى متجر المملكة المتحدة",
      toUAE: "إعادة توجيه إلى متجر الإمارات",
      loading: "تحميل",
    },
    cookies: {
      title: "ملفات تعريف الارتباط",
      body:
        "نستخدم عدداً محدوداً من ملفات تعريف الارتباط لضمان عمل الموقع بسلاسة وفهم ما ينجح. لا إعلانات ولا بيع للبيانات.",
      accept: "قبول",
      decline: "رفض",
    },
    booking: {
      orderTitle: "طلب الصور",
      bookTitle: "احجز جلسة",
      replyNote: "نرد خلال 24 ساعة",
      name: "الاسم",
      org: "الحضانة / المدرسة",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      territory: "المنطقة",
      shootType: "نوع الجلسة",
      shootTypes: {
        "spring-summer": "الربيع / الصيف",
        "autumn-winter": "الخريف / الشتاء",
        graduation: "التخرج",
        schools: "المدارس",
        other: "أخرى",
      },
      message: "الرسالة",
      messagePlaceholderBook: "التواريخ، الفئة العمرية، أي تفاصيل…",
      messagePlaceholderOrder: "رمز المعرض، الكميات، أي تفاصيل…",
      send: "إرسال",
      sending: "جارٍ الإرسال…",
      success: "تم استلام طلب الحجز.",
      successOrder: "تم استلام طلب الصور. سنعاود الاتصال بك.",
      error: "حدث خطأ. يرجى التحقق من البيانات والمحاولة مجدداً.",
      validation: "يرجى إكمال الاسم والجهة والبريد الإلكتروني والهاتف.",
    },
    contactDialog: {
      title: "تواصل معنا",
      send: "إرسال",
      sending: "جارٍ الإرسال…",
      success: "تم استلام رسالتك. سنعاود التواصل قريباً.",
      error: "حدث خطأ. يرجى المحاولة مجدداً.",
      validation: "يرجى ملء الاسم والبريد الإلكتروني والرسالة.",
      name: "الاسم",
      email: "البريد الإلكتروني",
      message: "الرسالة",
    },
    notice: [
      "مرحباً بكم في لوف إكسكلوسيف للتصوير",
      "إعلان للحضانات / المدارس: احجزوا جلستكم القادمة لعام 2026 مبكراً لضمان تواريخكم",
      "يمكنكم الآن طلب صوركم عبر الإنترنت باستخدام رمز الدخول الخاص بكم",
      "إعلان: يمكن لطلبات الحجز المبكّر الحصول على خصم يصل إلى 15 جنيهاً إسترلينياً",
      "بمجرد تسجيلكم في الجلسة سيتم إعلامكم عندما تصبح الصور جاهزة للعرض",
      "سجّلوا طفلكم عبر تقنية رمز QR الجديدة في حضانتكم / مدرستكم",
      "لقد توسعنا الآن إلى الإمارات لتقديم خدمات التصوير للحضانات والمدارس",
    ],
    footer: {
      copyright:
        "© 2026 Love Exclusive Photography apart of Love Exclusive LLC © جميع الحقوق محفوظة.",
    },
    badge: {
      years: "سنوات",
      anniversary: "ذكرى",
      aria: "الذكرى العاشرة",
    },
    anniv: {
      kicker: "2016 — 2026",
      title: "نحتفل بعشر سنوات من الحب",
      subtitle: "شكراً لأنكم جزء من رحلتنا.",
      continue: "متابعة",
    },
    lang: { en: "English", ar: "العربية" },
  },
};

const LangContext = createContext(null);

function getNested(obj, path) {
  return path.split(".").reduce((acc, key) => (acc != null ? acc[key] : undefined), obj);
}

export function LangProvider({ children }) {
  const [lang, setLangState] = useState("en");

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved && LANG_CODES.includes(saved)) setLangState(saved);
    } catch (_) {}
  }, []);

  const setLang = useCallback((code) => {
    if (!LANG_CODES.includes(code)) return;
    setLangState(code);
    try {
      localStorage.setItem(STORAGE_KEY, code);
    } catch (_) {}
  }, []);

  const t = useCallback(
    (path, fallback) => {
      const value = getNested(TRANSLATIONS[lang], path);
      if (value != null) return value;
      const en = getNested(TRANSLATIONS.en, path);
      return en != null ? en : fallback ?? path;
    },
    [lang]
  );

  return (
    <LangContext.Provider value={{ lang, setLang, t, isRtl: lang === "ar" }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
